if (!window._babelPolyfill) {
  require('babel-polyfill');
}
require('./index');



//////////////////
// WEBPACK FOOTER
// ./src/entry.js
// module id = 962
// module chunks = 0